import {useState, useEffect, useRef} from 'react'
import firebase, {auth, firestore} from '../../firebase'
import {Spinner} from 'react-bootstrap'
import CalendarComponent from './CalendarComponent'
import ProgressBar from './ProgressBar'
import Button from 'react-bootstrap/Button';
import './calendarStyles.css'
const characters = [
    "Trevor Reznik",
    "Vice President Dick Cheney",
    "Marilyn Mansion",
    "Patrick Bateman",
    "The Batman",
    "Special Surprize"
]
const SPECIALCHARACTER = "Bruce Wayne"
const milestoneDays = [1,6,13,20,27,31]
const flares = [
    "/images/level1.png",
    "/images/level2.png",
    "/images/level3.png",
    "/images/level4.png",
    "/images/level6.png",
    "/images/level5.png",
    "/images/level5.png",
    

]




const Calendar=()=>{
    const [username, setUsername] = useState("")
    const [character, setCharacter] = useState("...")
    
    const [sideImage, setSideImage] = useState("/images/level1.jpg")
    const [hasFailed, setFailed] = useState(false)
    const [failDay, setFailDay] = useState(0)

    const [day, setDay] = useState()
    const [loading, setLoading] = useState(true)
    
    
    const selectedFailedDateRef = useRef(3)
    const [isForEdit, setForEdit] = useState(false)
    

    function getCharacterIndex(currDay){
        // find oldest younger brother to currDay
        let i = 0
        for (i; i < milestoneDays.length; i++){
            if (currDay < milestoneDays[i]){
                return i-1
            }
        }
        return milestoneDays.length - 1

    }
    const Message = ({day, character, characterIndex, hasFailed})=>{
        const [message, setMessage] = useState("")
        
        
        useEffect(()=>{
            const date = new Date()
            const month = date.getMonth()
            const ix = getCharacterIndex(day)
            updateSelectedDate(date.getDate())
            if (hasFailed){
                setMessage("You failed but you made it to day "+ failDay)
            }else{
                if (month == 10){
                    if (ix >= milestoneDays.length - 1){
                        setMessage(<div>{"Congratulations, you made it to day "+ day + " and unlocked all characters\n"}
                        <br/>
                        <img style={{width:"15vw"}} src="https://img1.picmix.com/output/stamp/normal/4/2/3/4/534324_71cd8.gif"/>
                        
                        </div>)
                    }else{
                        setMessage(<div>{characters[ix+1]} unlocks in {milestoneDays[ix+1]-day} days</div>)
                    }
            }else{
                setMessage(<div><img style={{width:"35vw"}} src="https://i.imgflip.com/84vft3.jpg"/></div>)
            }
            }
        },[])
        return <div>
            <h5 style={{textAlign:"center"}}>{message}</h5>
        </div>
    }
    function endStreak(){
        
        const userUid = auth.currentUser.uid
        const userDocRef = firestore.collection('users').doc(userUid);
        userDocRef.set({
            hasFailed: true,
            failDay: selectedFailedDateRef.current,
            username:auth.currentUser.displayName
          }).then(e=>{
            alert('streak frozen, congrats on partaking')
            window.location.reload()
          }).catch(e=>{
            alert("error freezing streak")
          })
        
    }
    function updateSelectedDate(date){

        selectedFailedDateRef.current = date
    }
    function getUserDocData(callback){

        const userUid = auth.currentUser.uid
        const userDocRef = firestore.collection('users').doc(userUid);
        userDocRef.get()
        .then((doc) => {
            if (doc.exists) {
                const userData = doc.data();
                callback(userData)
            }
            else{
                userDocRef.set({
                    hasFailed: false,
                    failDay: 1,
                    username:auth.currentUser.displayName
                  })
                  .then((doc) => {
                    callback({hasFailed:false, failDay:1})
                  })
                  .catch((error) => {
                    alert("error updating user data")
                    console.log(error)
                  });
            
            }
        }
        ).catch(e=>{
            console.log(e)

        })
    

    }
    useEffect(()=>{
        
        setUsername(auth.currentUser.displayName)
        

        let cb = (data)=>{
            setFailed(data.hasFailed)
            setFailDay(data.failDay)

            const currentDate = new Date()
            
            const currDay = currentDate.getDate()
            const currentMonth = currentDate.getMonth()
            if (data.hasFailed){
                setDay(currDay)
            }else{
                if (currentMonth == 10){
                    setDay(currDay)
                }else{
                    setDay(31)
                }
            }
            let ix = getCharacterIndex(currDay)
            if (data.hasFailed){
                ix = getCharacterIndex(data.failDay)
                setCharacter(characters[ix])
                if(data.failDay >= 27){
                    if(data.failDay == 27){
                        setSideImage(flares[ix])
                    }else{
                        setSideImage(flares[ix+1])
                    }
                }else{
                    setSideImage(flares[ix])
                }
                
            }else{
                if (currDay ==31 || currentMonth != 10){
                    setCharacter(SPECIALCHARACTER)
                    setSideImage(flares.pop())
                }else{

                setCharacter(characters[ix])
                if (currDay >= 27){
                    if(currDay == 27){
                    setSideImage(flares[ix])
                    }else{
                        setSideImage(flares[ix+1])
                    }
                }else{
                    setSideImage(flares[ix])
                }
                
                }
            }
            setLoading(false)
        }
        // if its november
        
        
        

        getUserDocData(cb)
        
            
        
    },[])

    return loading?<Spinner />:<div style={{fontFamily:"Poppins"}}>
        
        <div>
        <h1 style={{textAlign:"center"}}>Hi, {username}</h1>
        <h3 style={{textAlign:"center"}}>You are {character}</h3>
        <Message day={day} character={character} hasFailed={hasFailed} />
        
        </div>
        <div style={{display:"flex", flexDirection:'row'}}>
            <div style={{width:"75vh", marginTop:"2%", marginLeft:"7.5%"}}>
            <CalendarComponent day={day} milestoneDays={milestoneDays} hasFailed={hasFailed} failDay={failDay} isForEdit={isForEdit} setFailedDate={updateSelectedDate} />
            {hasFailed?<p>Congrats on participating in NNN 2023</p>: (!isForEdit?<Button variant="danger" style={{marginTop:'2%'}} onClick = {()=>setForEdit(true)}>End Your NNN streak</Button> :
            <div>   
                <h4>ℹ) Please select the date where your NNN streak ended, this is a permanent action, to honor the bro code please be honest </h4>
                <Button variant="danger" style={{marginTop:"2%"}} onClick = {()=>{endStreak()}}>End Streak (Permanent)⚠</Button>
                <Button variant="primary" style={{marginTop:"2%", marginLeft:"5%"}} onClick={()=>{setForEdit(false)}} >cancel</Button>
            </div>)
    }       

            <div style={{marginTop:"5%"}}> 
                <h3>Progress</h3>
                <ProgressBar percentage={hasFailed?(failDay*100/31).toFixed(2):(day*100/31).toFixed(2) }/>
            </div>
            </div>
            <div style={{marginTop:"2.5%"}}>
                <div style={{position:"absolute", marginLeft:"5%"}}> 
                {!hasFailed?<h2>You on Day {day}</h2>:<h2>You on day {failDay}</h2> }
                </div>
                <img src={sideImage} className="animated-img animating"/>
            </div> 
        </div>
        </div>
    
}
export default Calendar